import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { Observable } from 'rxjs'
import { ErrorStateMatcher } from '@angular/material/core'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'
import { type BrandDTO, type ModelDTO, type VehicleDTOExtended } from '../../../services/vehicles.service'
import { type CantonId } from '../../../services/appointments.service'
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { AsyncPipe, NgClass, NgTemplateOutlet, TitleCasePipe } from '@angular/common'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { MatDivider } from '@angular/material/list'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatSelectModule } from '@angular/material/select'

@Component({
  selector: 'customer-portal-vehicle-picker',
  standalone: true,
  templateUrl: './vehicle-picker.component.html',
  imports: [
    MatRadioButton,
    MatRadioGroup,
    NgxSkeletonLoaderModule,
    MatDivider,
    ReactiveFormsModule,
    TitleCasePipe,
    AsyncPipe,
    NgTemplateOutlet,
    HubChildTranslateModule,
    NgClass,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule
  ]
})
export class VehiclePickerComponent {
  @Input() vehicles: VehicleDTOExtended[] = []
  @Input() brands: BrandDTO[] = []
  @Input() loading = false
  @Input() country: string
  @Input() showOtherOption = true
  @Input() cantons: Array<{ id: CantonId }> = []

  @Input() carsControl: FormControl = new FormControl(null)
  @Input() makeControl: FormControl
  @Input() modelControl: FormControl
  @Input() licencePlateDE: FormControl
  @Input() licencePlateCH: FormControl
  @Input() licencePlateCanton: FormControl<CantonId | null>

  @Input() filteredOptions: Observable<BrandDTO[]>
  @Input() filteredOptionsModels: Observable<ModelDTO[]>

  @Input() matcher: ErrorStateMatcher

  @Output() vehicleSelected = new EventEmitter<VehicleDTOExtended>()
  @Output() otherVehicleSelected = new EventEmitter<void>()
  @Output() brandSelected = new EventEmitter<string>()

  isOtherSelected = false

  constructor (public transifexService: TransifexService) {}

  onOtherClicked (): void {
    this.isOtherSelected = true
    this.otherVehicleSelected.emit()
  }

  translateShared (key: string): string {
    const translation = this.transifexService.getSharedTranslation(key)
    return translation || key
  }
}
